module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/onboarding-reputación.5342c218.mp4";